import { fabricServiceModels } from '@infa-hawk/services';

export enum REGISTRATION_STATUS {
	LOADING,
	COMPLETED,
	FAILURE,
	FORCE_STOP,
	INPROGRESS,
	ORG_DOESNOT_EXIST,
}
type RegistrationResponse<T extends REGISTRATION_STATUS> = T extends REGISTRATION_STATUS.COMPLETED
	? { status: REGISTRATION_STATUS.COMPLETED; details: fabricServiceModels.IGetRegistrationResponse }
	: T extends REGISTRATION_STATUS.ORG_DOESNOT_EXIST
		? { status: REGISTRATION_STATUS.ORG_DOESNOT_EXIST; details: { registrationURL: string } }
		: { status: Exclude<REGISTRATION_STATUS, REGISTRATION_STATUS.COMPLETED | REGISTRATION_STATUS.ORG_DOESNOT_EXIST> };

export type TRegistrationDetails = RegistrationResponse<REGISTRATION_STATUS>;
export type TRegistrationDetailsMap = Record<string, RegistrationResponse<REGISTRATION_STATUS>>;
